import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {canCreateShareLinkPdfFromCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

export const cartActionCreatePDFShareIcon = faLink;

/**
 * Create pdf share link from cart
 * @param params
 * @returns Action
 */
export const cartActionCreatePDFShare = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'cart-create-pdf-share-link',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.CREATE_PDF_SHARE_LINK),
	enableTest: () => canCreateShareLinkPdfFromCurrentCart(),
	icon: cartActionCreatePDFShareIcon,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CREATE_PDF_SHARE_LINK;
	},
	...params,
});

export default cartActionCreatePDFShare;
